const barCode = {
  code: function(_, attributes) {
    const { code, type, codeName } = attributes;
    if (
      type !== "barcode" &&
      type !== "null" &&
      code.length &&
      ![8, 12, 13, 14].includes(code.length)
    ) {
      return {
        length: {
          minimum: 15,
          maximum: 15,
          message: `${codeName} deve conter 8, 12, 13 ou 14 caracteres.`
        }
      };
    } else if (type === "barcode" && code.length) {
      return {
        length: {
          minimum: 8,
          maximum: 14,
          message: `${codeName} deve conter entre 8 e 14 caracteres.`
        }
      };
    } else {
      return {
        barCode: {
          allowEmpty: true,
          message: `${codeName} inválido. Deve ser vazio ou conter um valor válido`
        }
      };
    }
  }
};

export default {
  barCode
};



// WEBPACK FOOTER //
// ./src/core/constraint/barcode.constraint.js